import { Component } from 'react';
import {connect} from 'react-redux';
import {saveImageContent} from '../../../../actions/content';
import ArrowButton from '../../../common/button-arrow';
import noPhoto from '../../../../assets/img/no_photo.png';
import './styles.css';

class ImageEditor extends Component {
  onSubmit = (event) => {
    event.preventDefault();
    const {file} = this.state;
    const {identifier, onContentSaved} = this.props;
    this.props.dispatch(saveImageContent(identifier, file))
      .then(() => {
        onContentSaved();
      });
  };
  handleImageChange = (e) => {
    e.preventDefault();

    const reader = new FileReader();
    const file = e.target.files[0];

    if (file) {
      reader.onloadend = () => {
        this.setState({
          file,
          imagePreviewUrl: reader.result
        });
      };

      reader.readAsDataURL(file);
    }
  };

  constructor(props) {
    super(props);
    this.state = {
      file: '',
      imagePreviewUrl: '',
    };
  }

  UNSAFE_componentWillReceiveProps(nextProps) {
    const {identifier} = this.props;
    if (identifier && nextProps.contents) {
      this.setState({
        imagePreviewUrl: nextProps.contents.image || ''
      });
    }
  }

  render() {
    const {imagePreviewUrl} = this.state;
    const {editContent} = this.props;
    let $imagePreview = null;
    if (imagePreviewUrl) {
      $imagePreview = (
        <div className="imgPreview">
          <img alt='loaded_preview' src={imagePreviewUrl}/>
        </div>
      );
    } else if (editContent) {
      $imagePreview = (
        <div className="imgPreview">
          <div className="previewText">
            Please select an Image for Preview
          </div>
        </div>
      );
    } else {
      $imagePreview = (
        <div className="imgPreview">
          <img alt='no_preview' src={noPhoto}/>
        </div>
      );
    }

    return (
      <div className="image-editor">
        {!editContent && $imagePreview}
        {
          editContent && (
            <div>
              <div className="edit-link">
                Edit image (upload)
              </div>
              <form onSubmit={e => this.onSubmit(e)}>
                <input
                  className="fileInput"
                  onChange={e => this.handleImageChange(e)}
                  type="file"
                />
                <ArrowButton
                  arrow={false}
                  disabled={!imagePreviewUrl}
                >
                  Save
                </ArrowButton>
              </form>
              {$imagePreview}
            </div>
          )}
      </div>
    );
  }
}

const mapStateToProps = state => ({
  editContent: state.viewConfig.editContent
});

export default connect(mapStateToProps)(ImageEditor);
